(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luke-product-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('luke-product-size-chart')) return;
  let dialog;
  let restore;
  let lastSource = '';
  const snapshot = (element) => ({
    element,
    x: element.scrollLeft,
    y: element.scrollTop,
    overflow: element.style.overflow,
    overflowX: element.style.overflowX,
    overflowY: element.style.overflowY,
  });
  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'luke-product-chart-dialog';
    dialog.innerHTML = '<div class="luke-product-chart-toolbar"><h2 class="luke-product-chart-title"></h2><button type="button" class="luke-product-chart-zoom" aria-pressed="false"></button><button type="button" class="luke-product-chart-close" autofocus></button></div><p class="luke-product-chart-error" role="status" hidden></p><div class="luke-product-chart-viewport"><img class="luke-product-chart-image" alt=""></div>';
    document.body.append(dialog);
    dialog.querySelector('.luke-product-chart-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('.luke-product-chart-zoom').addEventListener('click', () => {
      const viewport = dialog.querySelector('.luke-product-chart-viewport');
      const zoomed = viewport.toggleAttribute('data-zoomed');
      const button = dialog.querySelector('.luke-product-chart-zoom');
      button.setAttribute('aria-pressed', String(zoomed));
      button.textContent = zoomed ? dialog.dataset.zoomOut : dialog.dataset.zoomIn;
      viewport.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    });
    dialog.querySelector('img').addEventListener('error', () => {
      if (dialog.open && dialog.querySelector('img').getAttribute('src') === lastSource) {
        dialog.querySelector('.luke-product-chart-error').hidden = false;
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!restore) return;
      const previous = restore;
      restore = null;
      for (const entry of previous.scrollers) {
        entry.element.style.overflow = entry.overflow;
        entry.element.style.overflowX = entry.overflowX;
        entry.element.style.overflowY = entry.overflowY;
        entry.element.scrollTo({ left: entry.x, top: entry.y, behavior: 'instant' });
      }
      const scope = previous.sectionId ? document.getElementById(previous.sectionId) : document;
      const current = Array.from(scope?.querySelectorAll('.luke-product-chart-button') || []).find((button) => button.dataset.productId === previous.product);
      (previous.button.isConnected ? previous.button : current)?.focus({ preventScroll: true });
      window.scrollTo({ left: previous.x, top: previous.y, behavior: 'instant' });
      dialog.querySelector('img').removeAttribute('src');
      lastSource = '';
    });
  }
  function openChart(button) {
    if (!button?.isConnected || !button.dataset.chartSrc || typeof HTMLDialogElement === 'undefined') return;
    if (!dialog?.isConnected) buildDialog();
    if (dialog.open) return;
    const scrollers = [snapshot(document.documentElement), snapshot(document.body)];
    for (let element = button.parentElement; element && element !== document.body; element = element.parentElement) {
      if (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) scrollers.push(snapshot(element));
    }
    const image = dialog.querySelector('img');
    lastSource = button.dataset.chartSrc;
    image.setAttribute('src', lastSource);
    image.alt = button.dataset.chartAlt;
    const width = Number(button.dataset.chartWidth);
    const height = Number(button.dataset.chartHeight);
    if (width > 0 && height > 0) {
      image.width = width;
      image.height = height;
    }
    dialog.setAttribute('aria-label', button.dataset.chartTitle);
    dialog.querySelector('.luke-product-chart-title').textContent = button.dataset.chartTitle;
    dialog.querySelector('.luke-product-chart-close').textContent = button.dataset.chartClose;
    dialog.dataset.zoomIn = button.dataset.chartZoomIn;
    dialog.dataset.zoomOut = button.dataset.chartZoomOut;
    const zoom = dialog.querySelector('.luke-product-chart-zoom');
    zoom.textContent = button.dataset.chartZoomIn;
    zoom.setAttribute('aria-pressed', 'false');
    const error = dialog.querySelector('.luke-product-chart-error');
    error.textContent = button.dataset.chartError;
    error.hidden = true;
    const viewport = dialog.querySelector('.luke-product-chart-viewport');
    viewport.removeAttribute('data-zoomed');
    viewport.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    restore = { button, product: button.dataset.productId, sectionId: button.closest('.shopify-section')?.id || '', scrollers, x: window.scrollX, y: window.scrollY };
    try {
      dialog.showModal();
      for (const entry of scrollers) entry.element.style.overflow = 'hidden';
    } catch (error) {
      restore = null;
      image.removeAttribute('src');
      lastSource = '';
    }
  }
  customElements.define('luke-product-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.chartClick) return;
      this.chartClick = (event) => {
        const button = event.target.closest('.luke-product-chart-button');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        openChart(button);
      };
      this.addEventListener('click', this.chartClick);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luke-ring-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
  let dialog;
  let restore;
  const overflowState = (element) => ({ element, x: element.scrollLeft, y: element.scrollTop, overflow: element.style.overflow, overflowX: element.style.overflowX, overflowY: element.style.overflowY });
  document.addEventListener('click', (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const button = event.target.closest('.luke-ring-chart-button');
    if (!button || !button.dataset.chartSrc || typeof HTMLDialogElement === 'undefined') return;
    event.preventDefault();
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'luke-ring-chart-dialog';
      dialog.innerHTML = '<button type="button" class="luke-ring-chart-close" autofocus></button><img class="luke-ring-chart-image" width="930" height="930" alt="">';
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (click) => {
        if (click.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (click.clientX < rect.left || click.clientX > rect.right || click.clientY < rect.top || click.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!restore) return;
        for (const entry of restore.scrollers) {
          entry.element.style.overflow = entry.overflow;
          entry.element.style.overflowX = entry.overflowX;
          entry.element.style.overflowY = entry.overflowY;
          entry.element.scrollTo({ left: entry.x, top: entry.y, behavior: 'instant' });
        }
        const scope = restore.sectionId ? document.getElementById(restore.sectionId) : document;
        const current = Array.from(scope?.querySelectorAll('.luke-ring-chart-button') || []).find((item) => item.dataset.ringProduct === restore.product);
        (restore.button.isConnected ? restore.button : current)?.focus({ preventScroll: true });
        window.scrollTo({ left: restore.x, top: restore.y, behavior: 'instant' });
        restore = null;
        dialog.querySelector('img').removeAttribute('src');
      });
    }
    if (dialog.open) return;
    const scrollers = [overflowState(document.documentElement), overflowState(document.body)];
    for (let element = button.parentElement; element && element !== document.body; element = element.parentElement) {
      if (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) scrollers.push(overflowState(element));
    }
    restore = { button, product: button.dataset.ringProduct, sectionId: button.closest('.shopify-section')?.id || '', scrollers, x: window.scrollX, y: window.scrollY };
    dialog.setAttribute('aria-label', button.dataset.chartLabel);
    dialog.querySelector('button').textContent = button.dataset.chartClose;
    dialog.querySelector('img').src = button.dataset.chartSrc;
    dialog.querySelector('img').alt = button.dataset.chartAlt;
    for (const entry of scrollers) entry.element.style.overflow = 'hidden';
    dialog.showModal();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  let dialog;
  let restore;
  function openPreview(source, input) {
    if (!source?.isConnected || !input?.isConnected || !input.checked || !source.dataset.zoomSrc || typeof HTMLDialogElement === 'undefined') return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'luke-style-preview';
      dialog.setAttribute('aria-labelledby', 'luke-style-preview-caption');
      dialog.innerHTML = '<button type="button" class="luke-style-preview__close" autofocus></button><img class="luke-style-preview__image" alt=""><p class="luke-style-preview__caption" id="luke-style-preview-caption"></p>';
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!restore) return;
        document.documentElement.style.overflow = restore.htmlOverflow;
        document.documentElement.style.overflowX = restore.htmlOverflowX;
        document.documentElement.style.overflowY = restore.htmlOverflowY;
        document.body.style.overflow = restore.bodyOverflow;
        document.body.style.overflowX = restore.bodyOverflowX;
        document.body.style.overflowY = restore.bodyOverflowY;
        for (const entry of restore.scrollers) {
          entry.element.style.overflow = entry.overflow;
          entry.element.style.overflowX = entry.overflowX;
          entry.element.style.overflowY = entry.overflowY;
          entry.element.scrollTo({ left: entry.x, top: entry.y, behavior: 'instant' });
        }
        const scope = restore.picker?.isConnected ? restore.picker : document.getElementById(restore.sectionId);
        const current = Array.from(scope?.querySelectorAll('input[type="radio"]') || []).find((item) => item.name === restore.name && item.dataset.optionValueId === restore.optionId) || scope?.querySelector('input:checked');
        (current || (restore.input.isConnected ? restore.input : null))?.focus({ preventScroll: true });
        window.scrollTo({ left: restore.x, top: restore.y, behavior: 'instant' });
        restore = null;
        dialog.querySelector('img').removeAttribute('src');
      });
    }
    if (dialog.open) return;
    const scrollers = [];
    for (let element = input.parentElement; element && element !== document.body; element = element.parentElement) {
      if (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) {
        scrollers.push({ element, x: element.scrollLeft, y: element.scrollTop, overflow: element.style.overflow, overflowX: element.style.overflowX, overflowY: element.style.overflowY });
      }
    }
    restore = { input, scrollers, picker: input.closest('variant-picker'), sectionId: input.closest('.shopify-section')?.id || '', name: input.name, optionId: input.dataset.optionValueId, x: window.scrollX, y: window.scrollY, htmlOverflow: document.documentElement.style.overflow, htmlOverflowX: document.documentElement.style.overflowX, htmlOverflowY: document.documentElement.style.overflowY, bodyOverflow: document.body.style.overflow, bodyOverflowX: document.body.style.overflowX, bodyOverflowY: document.body.style.overflowY };
    dialog.querySelector('button').textContent = source.dataset.zoomClose;
    const image = dialog.querySelector('img');
    image.src = source.dataset.zoomSrc;
    image.alt = source.dataset.zoomLabel;
    dialog.querySelector('p').textContent = source.dataset.zoomLabel;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    for (const entry of scrollers) entry.element.style.overflow = 'hidden';
    dialog.showModal();
  }
  document.addEventListener('click', (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const source = event.target.closest('label')?.querySelector('.luke-style-zoom-source');
    if (!source) return;
    const input = source.closest('label')?.querySelector('input[type="radio"]');
    if (!input) return;
    if (event.target !== input) {
      event.preventDefault();
      input.click();
    }
    openPreview(source, input);
  }, true);
  document.addEventListener('keyup', (event) => {
    if (!event.isTrusted || !['Enter', ' '].includes(event.key)) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const source = input.closest('label')?.querySelector('.luke-style-zoom-source');
    if (!source) return;
    if (!input.checked) input.click();
    openPreview(source, input);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
